import { getCurrentAppName, getCurrentContextName } from '../../../supporting';

export const isHSEDesignOnlineContext = (): boolean =>
    getCurrentAppName() === 'deziiign' && getCurrentContextName() === 'online';
import { getCurrentAppName, getCurrentContextName } from '../../../supporting';

export const isHSEDesignOnlineContext = (): boolean =>
    getCurrentAppName() === 'deziiign' && getCurrentContextName() === 'online';
